import { useState, useEffect } from 'react';
import axios from 'axios';
import { API } from '../App';

const WelcomeModal = ({ user, setUser }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user && user.welcomed === false) {
      setOpen(true);
    }
  }, [user]);

  const dismiss = async () => {
    try {
      await axios.post(`${API}/user/dismiss-welcome`);
      const updated = { ...user, welcomed: true };
      setUser(updated);
      localStorage.setItem('user', JSON.stringify(updated));
    } catch (e) {
      // best-effort
    }
    setOpen(false);
  };

  if (!open || !user) return null;

  return (
    <div className="welcome-modal-overlay" data-testid="welcome-modal" onClick={dismiss}>
      <div className="welcome-modal" onClick={(e) => e.stopPropagation()}>
        <div className="welcome-modal-header">
          <i className="fa-solid fa-hand-holding-heart"></i>
          <h2>Welcome to CareGuard, {user.name?.split(' ')[0] || 'friend'}!</h2>
        </div>
        <p className="welcome-modal-tagline">
          You just joined a community built to keep caregivers like you safe and supported.
        </p>
        <ul className="welcome-modal-list">
          <li><i className="fa-solid fa-calendar-check" /> <span>Set your check-in schedule from Profile.</span></li>
          <li><i className="fa-solid fa-user-plus" /> <span>Add emergency contacts so help arrives if you miss a check-in.</span></li>
          <li><i className="fa-solid fa-people-group" /> <span>Browse the Caregiver Directory to connect with peers in your area.</span></li>
          <li><i className="fa-solid fa-heart-pulse" /> <span>Log your vitals and watch your wellness trends.</span></li>
        </ul>
        <button
          className="welcome-modal-btn"
          data-testid="welcome-modal-dismiss"
          onClick={dismiss}
        >
          Let's get started
        </button>
      </div>
    </div>
  );
};

export default WelcomeModal;
